import React, { useState, useEffect } from 'react'

import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Card, CardHeader, CardContent, TextField, Grid } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import validate from 'validate.js'
import { useSetorService } from 'hooks/useSetorService'
import useRouter from 'utils/useRouter'

const useStyles = makeStyles((theme) => ({
  root: {},
  alert: {
    marginBottom: theme.spacing(3),
  },
  formGroup: {
    marginBottom: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
  tags: {
    marginTop: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  dateField: {
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  enviarImagemComputador: {
    display: 'none',
  },
  fotos: {
    margin: theme.spacing(1),
  },
}))

const schema = {
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  sigla: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  descricao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  endereco: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  email: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  telefone: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
}

export const Formulario = (props) => {
  const { className, dados, editar, idPai, ...rest } = props
  const setorService = useSetorService()
  const classes = useStyles()
  const router = useRouter()

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  })

  useEffect(() => {
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        nome: dados.nome,
        sigla: dados.sigla,
        descricao: dados.descricao,
        divisao: dados.divisao,
        endereco: dados.endereco,
        telefone: dados.telefone,
        email: dados.email,
      },
    }))
    
  }, [dados])

  useEffect(() => {
    const errors = validate(formState.values, schema)

    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }))
    
  }, [formState.values])

  const handleChange = (event) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  const hasError = (field) => formState.touched[field] && formState.errors[field]

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (formState.isValid) {
      if (editar) {
        await setorService.editarSetor(dados.id, formState.values)
      } else {
        await setorService.cadastrarSetor(formState.values, idPai)
      }
      router.history.push('/orgaos/regionais/divisoes/setores/')
    }
  }

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <form
          id="form-edit-regional"
          onSubmit={handleSubmit}
          {...rest}
          className={clsx(classes.root, className)}
        >
          <Grid
            className={classes.fieldGroup}
            alignItems="center"
            container
            justifyContent="space-between"
            spacing={2}
          >
            <Grid className={classes.item} item md={6} sm={6} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('nome')}
                  fullWidth
                  helperText={hasError('nome') ? formState.errors.nome[0] : null}
                  label="Nome do setor"
                  name="nome"
                  onChange={handleChange}
                  value={formState.values.nome || ''}
                  required
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                    className: classes.labelInput,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid className={classes.item} item md={5} sm={5} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('sigla')}
                  fullWidth
                  helperText={hasError('sigla') ? formState.errors.sigla[0] : null}
                  label="Sigla"
                  name="sigla"
                  onChange={handleChange}
                  value={formState.values.sigla || ''}
                  required
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                    className: classes.labelInput,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('descricao')}
                  fullWidth
                  helperText={hasError('descricao') ? formState.errors.descricao[0] : null}
                  label="Descrição"
                  name="descricao"
                  onChange={handleChange}
                  value={formState.values.descricao || ''}
                  required
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                    className: classes.labelInput,
                  }}
                />
              </FormControl>
            </Grid>

            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <TextField
                fullWidth
                label="ENDEREÇO"
                variant="outlined"
                name="endereco"
                onChange={handleChange}
                value={formState.values.endereco || ''}
                InputLabelProps={{
                  shrink: true,
                  className: classes.labelInput,
                }}
              />
            </Grid>
            <Grid className={classes.item} item md={6} sm={6} xs={12}>
              <TextField
                fullWidth
                label="E-MAIL"
                variant="outlined"
                name="email"
                onChange={handleChange}
                value={formState.values.email || ''}
                InputLabelProps={{
                  shrink: true,
                  className: classes.labelInput,
                }}
              />
            </Grid>
            <Grid className={classes.item} item md={6} sm={6} xs={12}>
              <TextField
                fullWidth
                label="TELEFONE"
                variant="outlined"
                name="telefone"
                onChange={handleChange}
                value={formState.values.telefone || ''}
                InputLabelProps={{
                  shrink: true,
                  className: classes.labelInput,
                }}
              />
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  )
}
